"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var Link_1 = __importDefault(require("@mui/material/Link"));
var mountIsland_1 = require("../../mountIsland");
var Lang_js_1 = require("../../Lang.js");
var InternalNav_jsx_1 = __importDefault(require("../common/InternalNav.jsx"));
var VideoCard_jsx_1 = __importDefault(require("../common/VideoCard.jsx"));
var functions_jsx_1 = require("../common/functions.jsx");
var InfiniteScrollContainer_1 = __importDefault(require("../common/InfiniteScrollContainer"));
var PersonalUseBadge_jsx_1 = __importDefault(require("../common/PersonalUseBadge.jsx"));
var GroupItemGrid = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var itemResponse = _a.itemResponse;
    var _k = (0, react_1.useState)((itemResponse === null || itemResponse === void 0 ? void 0 : itemResponse.item) || null), groupItem = _k[0], setGroupItem = _k[1];
    var _l = (0, react_1.useState)(((_b = itemResponse === null || itemResponse === void 0 ? void 0 : itemResponse.item) === null || _b === void 0 ? void 0 : _b.videos) || []), videos = _l[0], setVideos = _l[1];
    var _m = (0, react_1.useState)(((_c = itemResponse === null || itemResponse === void 0 ? void 0 : itemResponse.item) === null || _c === void 0 ? void 0 : _c.pagination) || null), pagination = _m[0], setPagination = _m[1];
    var _o = (0, react_1.useState)(false), loadingMore = _o[0], setLoadingMore = _o[1];
    var _p = (0, react_1.useState)(null), error = _p[0], setError = _p[1];
    var _q = (0, react_1.useState)(null), removingVideoId = _q[0], setRemovingVideoId = _q[1];
    var _r = (0, react_1.useState)(null), reorderingVideoId = _r[0], setReorderingVideoId = _r[1];
    var _s = (0, react_1.useState)(false), deletingPlaylist = _s[0], setDeletingPlaylist = _s[1];
    var isMylist = (groupItem === null || groupItem === void 0 ? void 0 : groupItem.is_custom) === true;
    // Update state when itemResponse prop changes (e.g., navigating between playlists)
    (0, react_1.useEffect)(function () {
        if (itemResponse === null || itemResponse === void 0 ? void 0 : itemResponse.item) {
            setGroupItem(itemResponse.item);
            setVideos(itemResponse.item.videos || []);
            setPagination(itemResponse.item.pagination || null);
            setError(null);
        }
    }, [itemResponse]);
    var hasMore = pagination
        ? ((_d = pagination.page) !== null && _d !== void 0 ? _d : 1) < ((_e = pagination.total_pages) !== null && _e !== void 0 ? _e : 1)
        : false;
    var groupContext = {
        type: 'group',
        list: groupItem === null || groupItem === void 0 ? void 0 : groupItem.uniqid,
    };
    var loadMoreVideos = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var nextPage, apiUrl, response, data, updatedGroupItem, _a, newVideos_1, newPagination, rest_1, err_1;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!(groupItem === null || groupItem === void 0 ? void 0 : groupItem.uniqid) || !hasMore)
                        return [2 /*return*/];
                    setLoadingMore(true);
                    setError(null);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 4, 5, 6]);
                    nextPage = ((_b = pagination === null || pagination === void 0 ? void 0 : pagination.page) !== null && _b !== void 0 ? _b : 1) + 1;
                    apiUrl = (_c = groupItem === null || groupItem === void 0 ? void 0 : groupItem.permalinks) === null || _c === void 0 ? void 0 : _c.api;
                    if (!apiUrl)
                        throw new Error('Missing group API URL');
                    return [4 /*yield*/, fetch("".concat(apiUrl, "?page=").concat(nextPage), {
                            headers: { Accept: 'application/json' },
                        })];
                case 2:
                    response = _d.sent();
                    if (!response.ok) {
                        throw new Error('Failed to load group videos');
                    }
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _d.sent();
                    updatedGroupItem = (data === null || data === void 0 ? void 0 : data.item) || {};
                    _a = updatedGroupItem.videos, newVideos_1 = _a === void 0 ? [] : _a, newPagination = updatedGroupItem.pagination, rest_1 = __rest(updatedGroupItem, ["videos", "pagination"]);
                    setVideos(function (prev) { return __spreadArray(__spreadArray([], prev, true), newVideos_1, true); });
                    setPagination(newPagination || pagination);
                    setGroupItem(function (prev) { return (__assign(__assign({}, prev), rest_1)); });
                    return [3 /*break*/, 6];
                case 4:
                    err_1 = _d.sent();
                    console.error(err_1);
                    setError((0, Lang_js_1.__)('Error loading more videos. Please try again.'));
                    return [3 /*break*/, 6];
                case 5:
                    setLoadingMore(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [groupItem === null || groupItem === void 0 ? void 0 : groupItem.uniqid, hasMore, pagination === null || pagination === void 0 ? void 0 : pagination.page, (_f = groupItem === null || groupItem === void 0 ? void 0 : groupItem.permalinks) === null || _f === void 0 ? void 0 : _f.api]);
    var handleRemoveVideo = function (videoId, videoUniqid) { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, err_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!isMylist || !(groupItem === null || groupItem === void 0 ? void 0 : groupItem.uniqid))
                        return [2 /*return*/];
                    if (!confirm((0, Lang_js_1.__)('Are you sure you want to remove this video from your list?'))) {
                        return [2 /*return*/];
                    }
                    setRemovingVideoId(videoId);
                    setError(null);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, 6, 7]);
                    return [4 /*yield*/, fetch("/api/v2/twi/mylist/".concat(groupItem.uniqid, "/video/").concat(encodeURIComponent(videoUniqid)), {
                            method: 'DELETE',
                            headers: {
                                'Accept': 'application/json',
                                'X-CSRF-TOKEN': ((_a = document.querySelector('meta[name="csrf-token"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) || '',
                            },
                        })];
                case 2:
                    response = _b.sent();
                    if (!!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _b.sent();
                    throw new Error(data.message || (0, Lang_js_1.__)('Failed to remove video from playlist'));
                case 4:
                    // Remove video from local state
                    setVideos(function (prev) { return prev.filter(function (v) { return v.id !== videoId; }); });
                    return [3 /*break*/, 7];
                case 5:
                    err_2 = _b.sent();
                    console.error(err_2);
                    setError(err_2 instanceof Error ? err_2.message : (0, Lang_js_1.__)('Failed to remove video from playlist'));
                    return [3 /*break*/, 7];
                case 6:
                    setRemovingVideoId(null);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleReorderVideo = function (videoId, direction) { return __awaiter(void 0, void 0, void 0, function () {
        var currentIndex, newIndex, newVideos, response, data, err_3;
        var _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!isMylist || !(groupItem === null || groupItem === void 0 ? void 0 : groupItem.uniqid))
                        return [2 /*return*/];
                    currentIndex = videos.findIndex(function (v) { return v.id === videoId; });
                    if (currentIndex === -1)
                        return [2 /*return*/];
                    newIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1;
                    if (newIndex < 0 || newIndex >= videos.length)
                        return [2 /*return*/];
                    setReorderingVideoId(videoId);
                    setError(null);
                    newVideos = __spreadArray([], videos, true);
                    _a = [newVideos[newIndex], newVideos[currentIndex]], newVideos[currentIndex] = _a[0], newVideos[newIndex] = _a[1];
                    setVideos(newVideos);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 5, 6, 7]);
                    return [4 /*yield*/, fetch("/api/v2/twi/mylist/".concat(groupItem.uniqid, "/reorder"), {
                            method: 'PUT',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'X-CSRF-TOKEN': ((_b = document.querySelector('meta[name="csrf-token"]')) === null || _b === void 0 ? void 0 : _b.getAttribute('content')) || '',
                            },
                            body: JSON.stringify({
                                playlist: newVideos.map(function (v) { return v.uniqid; })
                            }),
                        })];
                case 2:
                    response = _c.sent();
                    if (!!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _c.sent();
                    throw new Error(data.message || (0, Lang_js_1.__)('Failed to save playlist order'));
                case 4: return [3 /*break*/, 7];
                case 5:
                    err_3 = _c.sent();
                    console.error(err_3);
                    setError(err_3 instanceof Error ? err_3.message : (0, Lang_js_1.__)('Failed to save playlist order'));
                    // Revert on error
                    setVideos(videos);
                    return [3 /*break*/, 7];
                case 6:
                    setReorderingVideoId(null);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleDeletePlaylist = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, err_4;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!isMylist || !(groupItem === null || groupItem === void 0 ? void 0 : groupItem.uniqid))
                        return [2 /*return*/];
                    if (!confirm((0, Lang_js_1.__)('Are you sure you want to delete this entire playlist? This cannot be undone.'))) {
                        return [2 /*return*/];
                    }
                    setDeletingPlaylist(true);
                    setError(null);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, fetch("/api/v2/twi/mylist/".concat(groupItem.uniqid), {
                            method: 'DELETE',
                            headers: {
                                'Accept': 'application/json',
                                'X-CSRF-TOKEN': ((_a = document.querySelector('meta[name="csrf-token"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) || '',
                            },
                        })];
                case 2:
                    response = _b.sent();
                    if (!!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _b.sent();
                    throw new Error(data.message || (0, Lang_js_1.__)('Failed to delete playlist'));
                case 4:
                    // Redirect to mylists index page after successful deletion
                    window.location.href = '/app/twi/mylists';
                    return [3 /*break*/, 6];
                case 5:
                    err_4 = _b.sent();
                    console.error(err_4);
                    setError(err_4 instanceof Error ? err_4.message : (0, Lang_js_1.__)('Failed to delete playlist'));
                    setDeletingPlaylist(false);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var imageUrl = (0, functions_jsx_1.bcImageResize)((_g = groupItem === null || groupItem === void 0 ? void 0 : groupItem.preview_image_url) !== null && _g !== void 0 ? _g : 'https://now.cdn.msia.org/images/j-r/17.jpg', '1160x652');
    var imageSrcSet = (groupItem === null || groupItem === void 0 ? void 0 : groupItem.preview_image_url)
        ? "".concat((0, functions_jsx_1.bcImageResize)(groupItem === null || groupItem === void 0 ? void 0 : groupItem.preview_image_url, '400x300'), " 435w, ").concat((0, functions_jsx_1.bcImageResize)(groupItem === null || groupItem === void 0 ? void 0 : groupItem.preview_image_url, '580x326'), " 580w, ").concat((0, functions_jsx_1.bcImageResize)(groupItem === null || groupItem === void 0 ? void 0 : groupItem.preview_image_url, '377x212'), " 377w")
        : '';
    var imageSizes = '(max-width: 500px) 435px, (min-width: 1200px) 377px, 580px';
    return (react_1.default.createElement("div", { className: "results-page" },
        react_1.default.createElement("div", { className: "results-header-container" },
            react_1.default.createElement("div", { className: "results-header-inner" },
                react_1.default.createElement("div", { className: "results-header-top-row" },
                    react_1.default.createElement("div", { className: "results-breadcrumb" },
                        react_1.default.createElement(Link_1.default, { href: ((_h = groupItem.parent_links) === null || _h === void 0 ? void 0 : _h.web) || '/app/twi', className: "video-breadcrumb-link", color: "inherit", underline: "hover" },
                            react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", style: { marginRight: '6px', verticalAlign: 'middle' } },
                                react_1.default.createElement("polyline", { points: "15 18 9 12 15 6" })),
                            ((_j = groupItem.parent_links) === null || _j === void 0 ? void 0 : _j.web) ? (0, Lang_js_1.__)('View All') : (0, Lang_js_1.__)('TWI'))),
                    react_1.default.createElement("div", { className: "hero__sidebar" },
                        react_1.default.createElement(InternalNav_jsx_1.default, { isLoggedIn: true }))),
                react_1.default.createElement("div", { className: "results-title-wrapper" },
                    react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
                        react_1.default.createElement("h1", { className: "results-page-title" }, groupItem.name),
                        isMylist && groupItem.name !== 'My List' && (react_1.default.createElement(Button_1.default, { onClick: handleDeletePlaylist, disabled: deletingPlaylist, className: "mylist-delete-playlist-btn", title: (0, Lang_js_1.__)('Delete playlist'), variant: "contained", color: "error", sx: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                fontSize: '14px',
                                opacity: deletingPlaylist ? 0.7 : 1,
                            } },
                            react_1.default.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
                                react_1.default.createElement("polyline", { points: "3 6 5 6 21 6" }),
                                react_1.default.createElement("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })),
                            deletingPlaylist ? (0, Lang_js_1.__)('Deleting...') : (0, Lang_js_1.__)('Delete Playlist')))),
                    react_1.default.createElement("hr", { className: "results-divider" })),
                react_1.default.createElement(Link_1.default, { href: groupItem.videos && groupItem.videos.length > 0 ? groupItem.videos[0].permalinks.web : '/app/twi', className: "group-card__link", color: "inherit", underline: "none" },
                    react_1.default.createElement("div", { className: "group-card group-card--details" },
                        react_1.default.createElement("div", { className: "group-card__hero-container", style: { backgroundImage: "url(".concat(imageUrl, ")") } },
                            react_1.default.createElement("div", { className: "group-card__hero-overlay" }, imageUrl && (react_1.default.createElement("img", { src: imageUrl, srcSet: imageSrcSet, sizes: imageSizes, alt: groupItem.name, className: "group-card__thumbnail", loading: "lazy", decoding: "async" })))),
                        react_1.default.createElement("div", { className: "play-button-overlay" },
                            react_1.default.createElement("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "#3c3630" },
                                react_1.default.createElement("path", { d: "M8 5v14l11-7z" }))),
                        react_1.default.createElement("div", { className: "group-card__info" },
                            react_1.default.createElement("h2", { className: "group-card__title" }, groupItem.name),
                            groupItem.description && (react_1.default.createElement("p", { className: "group-card__description" }, groupItem.description)),
                            react_1.default.createElement("div", { className: "group-card__badges" },
                                groupItem.is_audiobook && (react_1.default.createElement("span", { className: "group-card__badge" }, (0, Lang_js_1.__)('Audiobook'))),
                                groupItem.is_collection && (react_1.default.createElement("span", { className: "group-card__badge" }, (0, Lang_js_1.__)('Collection'))),
                                Array.isArray(groupItem.usage_type) && (function () {
                                    var types = groupItem.usage_type;
                                    var nonRestrictive = ['public', 'personal', 'personal use'];
                                    var restrictiveTypes = types.filter(function (t) { return !nonRestrictive.includes(t.toLowerCase()); });
                                    if (restrictiveTypes.length > 0) {
                                        return restrictiveTypes.map(function (t, i) { return (react_1.default.createElement("span", { key: i, className: "group-card__badge video-card__badge--minister" }, t)); });
                                    }
                                    if (types.some(function (t) { return t.toLowerCase() === 'personal' || t.toLowerCase() === 'personal use'; })) {
                                        return react_1.default.createElement(PersonalUseBadge_jsx_1.default, { badgeClass: "group-card__badge video-card__badge--personal" });
                                    }
                                    return null;
                                })(),
                                groupItem.visibility === 'SVOD Only' && (react_1.default.createElement("span", { className: "group-card__badge video-card__badge--premium", style: { marginLeft: 'auto' } }, (0, Lang_js_1.__)('Premium'))),
                                !groupItem.is_audiobook && !groupItem.is_collection && Array.isArray(groupItem.asset_type) && groupItem.asset_type.length > 0 && (react_1.default.createElement("span", { className: "group-card__badge" }, groupItem.asset_type.join(', '))),
                                typeof groupItem.video_count === 'number' && (react_1.default.createElement("span", { className: "group-card__badge group-card__badge--plain" },
                                    groupItem.video_count,
                                    " ",
                                    groupItem.video_count === 1 ? (0, Lang_js_1.__)('Item') : (0, Lang_js_1.__)('Items'))),
                                groupItem.is_custom && (react_1.default.createElement("span", { className: "group-card__badge group-card__badge--custom" }, (0, Lang_js_1.__)('My List'))))))))),
        react_1.default.createElement("div", { className: "results-main-section" },
            error && react_1.default.createElement("div", { className: "results-error" }, error),
            videos.length > 0 && (react_1.default.createElement(InfiniteScrollContainer_1.default, { dataLength: videos.length, hasMore: hasMore, loadMore: loadMoreVideos },
                react_1.default.createElement("div", { className: "video-grid", key: groupItem === null || groupItem === void 0 ? void 0 : groupItem.uniqid }, videos.map(function (video, index) { return (react_1.default.createElement("div", { key: "".concat(video.uniqid, "-").concat(index), className: "video-grid__item", style: { position: 'relative' } },
                    react_1.default.createElement(VideoCard_jsx_1.default, { video: video }),
                    isMylist && (react_1.default.createElement("div", { className: "mylist-controls", style: {
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            display: 'flex',
                            gap: '4px'
                        } },
                        index > 0 && (react_1.default.createElement(IconButton_1.default, { onClick: function () { return handleReorderVideo(video.id, 'up'); }, disabled: reorderingVideoId === video.id, className: "mylist-control-btn", title: (0, Lang_js_1.__)('Move up'), sx: {
                                background: 'rgba(255, 255, 255, 0.95)',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                padding: '4px 6px',
                            } },
                            react_1.default.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "#333", strokeWidth: "2" },
                                react_1.default.createElement("polyline", { points: "18 15 12 9 6 15" })))),
                        index < videos.length - 1 && (react_1.default.createElement(IconButton_1.default, { onClick: function () { return handleReorderVideo(video.id, 'down'); }, disabled: reorderingVideoId === video.id, className: "mylist-control-btn", title: (0, Lang_js_1.__)('Move down'), sx: {
                                background: 'rgba(255, 255, 255, 0.95)',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                padding: '4px 6px',
                            } },
                            react_1.default.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "#333", strokeWidth: "2" },
                                react_1.default.createElement("polyline", { points: "6 9 12 15 18 9" })))),
                        react_1.default.createElement(IconButton_1.default, { onClick: function () { return handleRemoveVideo(video.id, video.uniqid); }, disabled: removingVideoId === video.id, className: "mylist-control-btn mylist-remove-btn", title: (0, Lang_js_1.__)('Remove from list'), sx: {
                                background: 'rgba(220, 53, 69, 0.95)',
                                color: 'white',
                                border: '1px solid #dc3545',
                                borderRadius: '4px',
                                padding: '4px 6px',
                            } },
                            react_1.default.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
                                react_1.default.createElement("polyline", { points: "3 6 5 6 21 6" }),
                                react_1.default.createElement("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" }),
                                react_1.default.createElement("line", { x1: "10", y1: "11", x2: "10", y2: "17" }),
                                react_1.default.createElement("line", { x1: "14", y1: "11", x2: "14", y2: "17" }))))))); })))),
            videos.length === 0 && !loadingMore && (react_1.default.createElement("p", null, (0, Lang_js_1.__)('No media found in this group.'))),
            hasMore && (react_1.default.createElement("div", { className: "group-load-more" },
                react_1.default.createElement(Button_1.default, { variant: "outlined", onClick: loadMoreVideos, disabled: loadingMore }, loadingMore ? (0, Lang_js_1.__)('Loading...') : (0, Lang_js_1.__)('Load more')))))));
};
var container = document.getElementById('groups-show');
var itemResponse = container ? JSON.parse(container.getAttribute('data-itemResponse') || 'null') : null;
if (container) {
    (0, mountIsland_1.mountIsland)(container, react_1.default.createElement(GroupItemGrid, { itemResponse: itemResponse }));
}
